var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 37,
    height: 45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.482 44.2144C21.9857 37.9088 39.4402 24.1106 39.6164 23.9719C40.5201 23.2613 40.5201 21.7387 39.6164 21.0281C39.4402 20.8894 21.9876 7.09497 17.482 0.785613C17.1295 0.29251 16.5614 -1.03739e-06 15.9558 -1.06387e-06L6.58079 -1.47366e-06C5.87766 -1.50439e-06 5.23451 0.391844 4.91389 1.01623C4.59327 1.64062 4.64765 2.39245 5.05634 2.96622L5.63761 3.77994C9.26008 8.85178 20.2232 18.8005 24.3763 22.4999C20.2232 26.1993 9.26008 36.148 5.63761 41.2199L5.05634 42.0336C4.82389 42.358 4.70569 42.7405 4.70569 43.1248C4.70569 43.4173 4.77509 43.7117 4.91379 43.9836C5.23441 44.608 5.87757 44.9998 6.58069 44.9998L15.9557 44.9998C16.5614 45 17.1295 44.7075 17.482 44.2144Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C16.4901 45 10.8397 42.6596 6.59008 38.4099C2.34043 34.1603 0 28.5099 0 22.5C0 16.4901 2.34043 10.8397 6.59008 6.59008C10.8397 2.34043 16.4901 0 22.5 0C28.5099 0 34.1603 2.34043 38.4099 6.59008C42.6596 10.8397 45 16.4901 45 22.5C45 28.5099 42.6596 34.1603 38.4099 38.4099C34.1603 42.6596 28.5099 45 22.5 45ZM22.5 3.51562C12.0321 3.51562 3.51562 12.0321 3.51562 22.5C3.51562 32.9679 12.0321 41.4844 22.5 41.4844C32.9679 41.4844 41.4844 32.9679 41.4844 22.5C41.4844 12.0321 32.9679 3.51562 22.5 3.51562ZM31.6657 22.5L19.5117 10.346L17.0257 12.832L26.6937 22.5L17.0257 32.168L19.5117 34.654L31.6657 22.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -419,
    y: -120,
    width: 526,
    height: 612,
    fill: "url(#cyan-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -419,
    y: -120,
    width: 526,
    height: 612,
    fill: "url(#white-gradient)",
    opacity: 0
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyan-gradient",
    x1: -156,
    y1: -120,
    x2: -156,
    y2: 492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-gradient",
    x1: -156,
    y1: -120,
    x2: -156,
    y2: 492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(45) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.27d719ed.svg";
export { ForwardRef as ReactComponent };